import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import type { ReactNode } from 'react';

interface SheetProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  /** 画面下部に固定する操作エリア */
  footer?: ReactNode;
  /** md 以上で表示するときの最大幅 */
  className?: string;
}

/**
 * スマホでは画面下から出るシート、md 以上では中央のダイアログとして表示する。
 */
export const Sheet = ({ open, onClose, title, children, footer, className }: SheetProps) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="dialog-overlay" />
      <div className="fixed inset-0 flex items-end md:items-center md:justify-center md:p-4">
        <DialogPanel
          className={clsx(
            'flex w-full max-h-[92dvh] flex-col bg-white shadow-xl transition duration-300 data-[closed]:translate-y-8 data-[closed]:opacity-0 md:max-h-[85vh] md:max-w-2xl',
            className,
          )}
        >
          <div className="flex items-center justify-between gap-2 border-b border-neutral-200 py-1 pl-4 pr-1">
            <DialogTitle as="h3">{title}</DialogTitle>
            <button
              type="button"
              onClick={onClose}
              aria-label="閉じる"
              className="flex size-11 shrink-0 cursor-pointer items-center justify-center text-zinc-800 hover:text-neutral-600"
            >
              <XMarkIcon className="size-6" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-4 py-4">{children}</div>
          {footer && (
            <div className="border-t border-neutral-200 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
              {footer}
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};
